/**
 * Donate page UPI box (inc/donate.php).
 *
 * Amount cards (.amount-card with an .amount-value) become a radio group; the box is built inside
 * .upi-pay: amount field, Indian-citizen declaration, QR code and UPI app link for the chosen amount,
 * the UPI ID with a copy button, and a WhatsApp link for the payment reference. The code stays hidden
 * until the declaration is ticked. Nothing runs without .upi-pay.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var cfg = window.ssfDonate || {};
	var t = window.ssfText || { f: String };
	var max = parseInt( cfg.max, 10 ) || 100000;

	function esc( s ) {
		var d = document.createElement( 'div' );
		d.textContent = s;
		return d.innerHTML;
	}

	function rupees( n ) {
		return '₹' + n.toLocaleString( 'en-IN' );
	}

	function cardAmount( card ) {
		var v = card.querySelector( '.amount-value' );
		return parseInt( ( v ? v.textContent : '' ).replace( /[^0-9]/g, '' ), 10 ) || 0;
	}

	function upiLink( amount ) {
		return 'upi://pay?pa=' + cfg.upi +
			'&pn=' + encodeURIComponent( cfg.payee || '' ) +
			'&am=' + amount + '.00&cu=INR&tn=' + encodeURIComponent( 'Donation' );
	}

	// QR as one SVG path, four modules of quiet zone, in the page's ink colour.
	function qrSvg( text ) {
		if ( 'function' !== typeof window.qrcode ) {
			return '';
		}
		var qr = window.qrcode( 0, 'M' );
		qr.addData( text );
		qr.make();
		var n = qr.getModuleCount();
		var q = 4;
		var d = '';
		for ( var r = 0; r < n; r++ ) {
			for ( var c = 0; c < n; c++ ) {
				if ( qr.isDark( r, c ) ) {
					d += 'M' + ( c + q ) + ' ' + ( r + q ) + 'h1v1h-1z';
				}
			}
		}
		var s = n + q * 2;
		return '<svg viewBox="0 0 ' + s + ' ' + s + '" shape-rendering="crispEdges" aria-hidden="true" focusable="false"><rect width="' + s + '" height="' + s + '" fill="#fff"/><path d="' + d + '" fill="#1C1714"/></svg>';
	}

	function waLink( amount ) {
		return 'https://wa.me/' + t.wa + '?text=' + encodeURIComponent( t.f( t.don_wa_msg, rupees( amount ) ) );
	}

	function setup( holder ) {
		var section = holder.closest( 'section' ) || document;
		var grid = section.querySelector( '.amount-grid' );
		var cards = Array.prototype.slice.call( section.querySelectorAll( '.amount-card' ) );
		var start = parseInt( cfg.amount, 10 ) || ( cards[ 0 ] ? cardAmount( cards[ 0 ] ) : 501 );
		// The UPI ID can also be written on the page in Elementor (a paragraph with class upi-source);
		// the Settings value wins. The line is hidden once the box shows the ID with its Copy button.
		var src = section.querySelector( '.upi-source' );
		if ( src ) {
			var m = src.textContent.match( /[a-z0-9._-]{2,256}@[a-z][a-z0-9.]{1,63}/i );
			if ( ! cfg.upi && m ) {
				cfg.upi = m[ 0 ].toLowerCase();
			}
			src.hidden = true;
		}
		var hasUpi = !! cfg.upi;

		holder.innerHTML =
			'<div class="upi-f">' +
			'<div class="upi-field"><label for="upi-amount">' + esc( t.don_amount ) + '</label>' +
			'<div class="upi-amt"><span aria-hidden="true">₹</span><input id="upi-amount" inputmode="numeric" autocomplete="off" maxlength="6" value="' + start + '" aria-describedby="upi-amount-err"></div>' +
			'<p class="upi-err" id="upi-amount-err" role="alert"></p></div>' +
			'<label class="upi-check"><input type="checkbox" id="upi-citizen"><span>' + esc( t.don_citizen ) + '</span></label>' +
			'<div class="upi-out" aria-live="polite"></div>' +
			'<p class="upi-fine">' + esc( t.don_fine ) + ' <a href="' + esc( t.privacy ) + '">' + esc( t.privacy_link ) + '</a>.</p>' +
			'</div>';

		var input = holder.querySelector( '#upi-amount' );
		var err = holder.querySelector( '#upi-amount-err' );
		var tick = holder.querySelector( '#upi-citizen' );
		var out = holder.querySelector( '.upi-out' );

		function amount() {
			var v = input.value.replace( /[^0-9]/g, '' );
			return v ? parseInt( v, 10 ) : 0;
		}

		function render() {
			var a = amount();
			var ok = a >= 1 && a <= max;
			input.setAttribute( 'aria-invalid', ok ? 'false' : 'true' );
			err.textContent = ok ? '' : ( a > max ? t.f( t.err_amount_max, rupees( max ) ) : t.err_amount );

			if ( ! tick.checked ) {
				out.innerHTML = '<p class="upi-wait">' + esc( t.don_wait ) + '</p>';
				return;
			}
			if ( ! hasUpi ) {
				out.innerHTML = '<p class="upi-wait">' + t.f( esc( t.don_no_upi ), '<a href="tel:' + esc( t.tel ) + '">' + esc( t.phone ) + '</a>' ) + '</p>';
				return;
			}
			if ( ! ok ) {
				out.innerHTML = '';
				return;
			}
			var link = upiLink( a );
			out.innerHTML =
				'<div class="upi-code"><div class="upi-qr" role="img" aria-label="UPI QR code for ' + esc( rupees( a ) ) + ' to ' + esc( cfg.payee ) + '">' + qrSvg( link ) + '</div>' +
				'<p class="upi-scan">' + t.f( esc( t.don_scan ), '<b>' + esc( rupees( a ) ) + '</b>' ) + '</p></div>' +
				'<a class="upi-app" href="' + esc( link ) + '">' + esc( t.f( t.don_app, rupees( a ) ) ) + '</a>' +
				'<p class="upi-id">' + esc( t.don_upi_label ) + ' <b>' + esc( cfg.upi ) + '</b> <button type="button" class="upi-copy">' + esc( t.don_copy ) + '</button></p>' +
				'<a class="upi-wa" href="' + esc( waLink( a ) ) + '" target="_blank" rel="noopener">' + esc( t.don_wa ) + '</a>';

			var copy = out.querySelector( '.upi-copy' );
			copy.addEventListener( 'click', function () {
				var done = function () {
					copy.textContent = t.don_copied;
					setTimeout( function () {
						copy.textContent = t.don_copy;
					}, 2000 );
				};
				if ( navigator.clipboard && navigator.clipboard.writeText ) {
					navigator.clipboard.writeText( cfg.upi ).then( done, function () {} );
				}
			} );
		}

		// Amount cards: a radio group with arrow keys, as the native control would behave.
		function select( card, focus ) {
			cards.forEach( function ( c ) {
				var on = c === card;
				c.setAttribute( 'aria-checked', on ? 'true' : 'false' );
				c.setAttribute( 'tabindex', on ? '0' : '-1' );
			} );
			if ( card ) {
				input.value = cardAmount( card );
				if ( focus ) {
					card.focus();
				}
			}
			render();
		}

		function syncCards() {
			var a = amount();
			var match = null;
			cards.forEach( function ( c ) {
				if ( cardAmount( c ) === a ) {
					match = c;
				}
			} );
			cards.forEach( function ( c ) {
				c.setAttribute( 'aria-checked', c === match ? 'true' : 'false' );
				c.setAttribute( 'tabindex', c === match || ( ! match && c === cards[ 0 ] ) ? '0' : '-1' );
			} );
		}

		if ( grid ) {
			grid.setAttribute( 'role', 'radiogroup' );
			grid.setAttribute( 'aria-label', t.don_choose );
		}
		cards.forEach( function ( c, i ) {
			c.setAttribute( 'role', 'radio' );
			c.addEventListener( 'click', function () {
				select( c );
			} );
			c.addEventListener( 'keydown', function ( e ) {
				var next = null;
				if ( 'ArrowRight' === e.key || 'ArrowDown' === e.key ) {
					next = cards[ ( i + 1 ) % cards.length ];
				} else if ( 'ArrowLeft' === e.key || 'ArrowUp' === e.key ) {
					next = cards[ ( i - 1 + cards.length ) % cards.length ];
				} else if ( ' ' === e.key || 'Enter' === e.key ) {
					e.preventDefault();
					select( c );
					return;
				}
				if ( next ) {
					e.preventDefault();
					select( next, true );
				}
			} );
		} );

		input.addEventListener( 'input', function () {
			var clean = input.value.replace( /[^0-9]/g, '' ).replace( /^0+/, '' );
			if ( clean !== input.value ) {
				input.value = clean;
			}
			syncCards();
			render();
		} );
		tick.addEventListener( 'change', render );

		syncCards();
		render();
	}

	function init() {
		Array.prototype.forEach.call( document.querySelectorAll( '.upi-pay' ), setup );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
